export default "__VITE_ASSET__3d53140d__"